export const routes = {
  analytics: '/analytics',
  conversations: '/conversations',
  conversationTemplates: '/conversations/templates',
  create: '/create',
  customers: '/customers',
  forgotPassword: '/forgot-password',
  login: '/login',
  overview: '/overview',
  products: '/products',
  productsBulkUpload: '/products/bulk-upload',
  profile: '/profile',
  root: '/',
  settings: '/settings',
  signUp: '/sign-up',
  store: '/store',
  sales: '/sales',
  transactions: '/transactions',
  storeBuilder: '/store/create',
  miniStore: '/mini-store',
  support: '/support',
  shipping: '/shipping',
  kyb: '/kyb',
  billing: '/billing',
  billingSummary: '/billing/summary',
  referAndEarn: '/refer-and-earn',
};
